export enum ApiResponseErrorCodes {
    InvalidParameters = 'invalidParameters',
    MissingParameters = 'missingParameters',
    UserNotFound = 'userNotFound',
    MissingAuthenticationKey = 'missingAuthenticationKey',
    InvalidAuthenticationKey = 'invalidAuthenticationKey',
    MinimumRoleNotSatisfied = 'minimumRoleNotSatisfied',
    MissingPermissions = 'missingPermissions',
    AlreadyExistsUserWithSameEmail = 'alreadyExistsUserWithSameEmail',
    AlreadyExistsUserWithSameWallet = 'alreadyExistsUserWithSameWallet',
    UserBadCredentials = 'userBadCredentials',
    UserNotActive = 'userNotActive',
    PurchasedTicketAlreadyExists = 'purchasedTicketAlreadyExists',
    VotedTicketAlreadyExists = 'votedTicketAlreadyExists',
    TransactionNotExists = 'transactionNotExists'
}